<script>
import axios from '@/utils/axios';

export default {
 inject: ['setLoading'],
 data() {
  return {
   challan: null,
   admin: null,
  };
 },

 computed: {
  parsedTaxBreakdown() {
   if (!this.challan?.tax_breakdown) return {};
   if (typeof this.challan.tax_breakdown === 'string') {
    try { return JSON.parse(this.challan.tax_breakdown); } catch { return {}; }
   }
   return this.challan.tax_breakdown;
  },
  hasTaxBreakdown() {
   return this.parsedTaxBreakdown && Object.keys(this.parsedTaxBreakdown).length > 0;
  },
 },

 async mounted() {
  const id = this.$route.params.id;
  await this.loadChallan(id);
  await this.loadAdmin();
 },

 methods: {

 async approveItems() {
  try {
    const result = await this.$swal({
      title: 'Approve Items?',
      text: `Are you sure you want to approve items of ${this.challan.challan_number}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, Approve',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#22c55e',
    });
    if (result.isConfirmed) {
      this.setLoading(true);
      const dc_item_ids = this.challan.challan_items.map(item => item.id);
      const response = await axios.post(`/inventory/delivery-challans/${this.challan.id}/items/approve`, {
        dc_item_ids: dc_item_ids
      });
      this.$swalToast(response.data.message);
      await this.loadChallan(this.challan.id);
    }
  } catch (error) {
    this.$swalToast(error.message, 'error');
  } finally {
    this.setLoading(false);
  }
},

async rejectItems() {
  try {
    const result = await this.$swal({
      title: 'Reject Items?',
      text: `Are you sure you want to reject items of ${this.challan.challan_number}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Reject',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#e84040',
    });
    if (result.isConfirmed) {
      this.setLoading(true);
      const dc_item_ids = this.challan.challan_items.map(item => item.id);
      const response = await axios.post(`/inventory/delivery-challans/${this.challan.id}/items/reject`, {
        dc_item_ids: dc_item_ids
      });
      this.$swalToast(response.data.message);
      await this.loadChallan(this.challan.id);
    }
  } catch (error) {
    this.$swalToast(error.message, 'error');
  } finally {
    this.setLoading(false);
  }
},

  async loadChallan(id) {
   this.setLoading(true);
   try {
    const response = await axios.get(`/inventory/delivery-challans/${id}`);
    this.challan = response.data.data;
   } catch (error) {
    this.$swalToast(error.message, 'error');
   } finally {
    this.setLoading(false);
   }
  },

  async loadAdmin() {
   try {
    const adminId = this.challan?.admin_id || this.clientAdmin?.id;
    if (adminId) {
     const response = await axios.get(`/admin/${adminId}`);
     this.admin = response.data.data;
    }
   } catch (error) {
    console.log('Admin load error:', error.message);
   }
  },

  formatDate(dateStr) {
   if (!dateStr) return '-';
   const d = new Date(dateStr);
   return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  },

recipientName() {
  if (!this.challan) return '-';
  if (this.challan.recipient_type === 'App\\Models\\Customer') {
    return this.challan.recipient?.company_name || this.challan.recipient?.name || '-';
  }
  if (this.challan.recipient_type === 'App\\Models\\WorkOrder') {
    return this.challan.recipient?.name || '-';
  }
  if (this.challan.recipient_type === 'App\\Models\\SalesExecutive') {
    return this.challan.recipient?.user?.name || '-';
  } if (this.challan.recipient_type === 'App\\Models\\InternalConsumption') {
      return this.challan.recipient?.name || '-';
  }
    // Engineer
    return this.challan.recipient?.user?.name || '-';
  },

recipientPhone() {
  if (!this.challan) return '';
  if (this.challan.recipient_type === 'App\\Models\\Customer') {
    return this.challan.recipient?.mobile || '';
  }
  if (this.challan.recipient_type === 'App\\Models\\WorkOrder') {
    return this.challan.recipient?.phone || '';
  }
  if (this.challan.recipient_type === 'App\\Models\\SalesExecutive') {
    return this.challan.recipient?.user?.mobile || '';

  } if (this.challan.recipient_type === 'App\\Models\\InternalConsumption') {
      return '';
  }
    return this.challan.recipient?.user?.mobile || '';
  },

recipientEmail() {
  if (!this.challan) return '';
  if (this.challan.recipient_type === 'App\\Models\\Customer') {
    return this.challan.recipient?.email || '';
  }
  if (this.challan.recipient_type === 'App\\Models\\WorkOrder') {
    return this.challan.recipient?.email || '';
  }
  if (this.challan.recipient_type === 'App\\Models\\SalesExecutive') {
    return this.challan.recipient?.user?.email || '';
  } if (this.challan.recipient_type === 'App\\Models\\InternalConsumption') {
      return '';
  }
    return this.challan.recipient?.user?.email || '';
  },
recipientType() {
  if (!this.challan) return '';
  const map = {
    'App\\Models\\Customer': 'Customer',
    'App\\Models\\WorkOrder': 'Work Order',
    'App\\Models\\Engineer': 'Engineer',
    'App\\Models\\SalesExecutive': 'Sales Executive',
    'App\\Models\\InternalConsumption': 'Internal Consumption',
  };
  return map[this.challan.recipient_type] || 'Unknown';
},


  goBack() {
   this.$router.push('/inventory/delivery-challans');
  },

  printPage() {
   window.print();
  },

 },
};
</script>

<style scoped>
table {
 border-collapse: collapse;
 border-spacing: 0;
 width: 100%;
}
td, th { vertical-align: top; padding: 0; }

.challan-container {
 width: 100%;
 max-width: 210mm;
 margin: 15mm auto 0 auto;
 background: #ffffff;
 padding: 0 10px 10px 10px;
 font-family: 'Arial', sans-serif;
 font-size: 10.5px;
 color: #333333;
 line-height: 1.4;
}

.text-right { text-align: right; }
.text-center { text-align: center; }
.text-uppercase { text-transform: uppercase; letter-spacing: 0.05em; }
.font-bold { font-weight: 700; }
.font-heavy { font-weight: 800; }
.text-dark { color: #000000; }
.text-gray { color: #666666; }

.fs-10 { font-size: 10px; }
.fs-11 { font-size: 11px; }
.fs-12 { font-size: 12px; }
.fs-14 { font-size: 14px; }

.bordered-box { border: 1px solid #000000; }

.header-title {
 background-color: #F5F5F5;
 border-bottom: 2px solid #000000;
 padding: 6px 0;
}

.detail-table td { padding: 2px 0; }

/* Items Table */
.items-table { margin-top: 8px; }
.items-table thead th {
 background-color: #F5F5F5;
 color: #333333;
 padding: 6px 8px;
 font-size: 9.5px;
 text-transform: uppercase;
 text-align: left;
 font-weight: 600;
 border: 1px solid #000000;
}
.items-table tbody td {
 padding: 4px 8px;
 border: 1px solid #000000;
 color: #333333;
}

/* Totals */
.totals-section { margin-top: 8px; page-break-inside: avoid; }

.totals-right-table {
 width: 100%;
 border-collapse: collapse;
}
.totals-right-table td {
 padding: 5px 8px;
 font-size: 10.5px;
}
.totals-right-table .label-cell {
 text-align: right;
 color: #666666;
 border-bottom: 1px solid #e0e0e0;
}
.totals-right-table .value-cell {
 text-align: right;
 font-weight: 700;
 color: #000000;
 border-bottom: 1px solid #e0e0e0;
 width: 120px;
}
.totals-right-table .grand-label {
 text-align: left;
 padding: 8px;
 font-size: 13px;
 font-weight: 800;
 color: #000000;
 background-color: #F5F5F5;
 border-top: 2px solid #000000;
}
.totals-right-table .grand-value {
 text-align: right;
 padding: 8px;
 font-size: 13px;
 font-weight: 800;
 color: #000000;
 background-color: #F5F5F5;
 border-top: 2px solid #000000;
}

.amount-in-words { padding: 6px 8px; }

.footer-line {
 margin-top: 15px;
 border-top: 1px dashed #CCCCCC;
 padding-top: 4px;
 font-size: 9px;
 color: #666666;
 text-align: center;
}

@media print {
 .challan-container {
  width: 210mm;
  height: 277mm;
  margin: 0 auto;
  padding: 10mm 5mm 5mm 5mm;
  box-sizing: border-box;
 }
 .no-print { display: none !important; }
 .totals-section, .items-table {
  page-break-inside: avoid !important;
 }
}
</style>

<template>
 <div class="content" v-if="challan">

  <!-- Action Buttons -->
  <div class="d-md-flex d-block align-items-center justify-content-end page-breadcrumb mb-3 mt-3 no-print">
   <div class="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">

    <span class="badge rounded-pill p-2"
     :class="{
      'bg-warning': challan.status === 'draft',
      'bg-success': challan.status === 'dispatched',
      'bg-info': challan.status === 'received',
      'bg-danger': challan.status === 'cancelled',
      'bg-warning': challan.status === 'partial_pending'
     }">
     {{ challan.status.charAt(0).toUpperCase() + challan.status.slice(1) }}
    </span>

    <a href="javascript:void(0);" class="btn btn-outline-secondary d-flex align-items-center" @click="goBack">
     <i class="ti ti-arrow-left me-2"></i>Back
    </a>

    <template v-if="challan.status === 'partial_pending'">
  <a href="javascript:void(0);" class="btn btn-success d-flex align-items-center" @click="approveItems">
    <i class="ti ti-check me-2"></i>Approve Items
  </a>
  <a href="javascript:void(0);" class="btn btn-danger d-flex align-items-center" @click="rejectItems">
    <i class="ti ti-x me-2"></i>Reject Items
  </a>
</template>

    <a href="javascript:void(0);" class="btn btn-dark d-flex align-items-center" @click="printPage">
     <i class="ti ti-printer me-2"></i>Print
    </a>

   </div>
  </div>

  <!-- Challan Document -->
  <div class="challan-container" style="position: relative;">

   <!-- Watermark -->
   <div style="opacity: 0.04; top:80px; position:absolute; left:0; right:0;" v-if="admin?.company?.watermark || admin?.company?.logo">
    <img :src="admin.company?.watermark_url || admin.company?.logo_url" alt="Watermark" style="width: 100%; height: auto;">
   </div>

   <!-- ========== HEADER ========== -->
   <table width="100%" cellpadding="0" cellspacing="0" class="bordered-box" style="position: relative; z-index: 1;">
    <thead>
     <tr>
      <td colspan="2" class="header-title text-center font-bold fs-14 text-uppercase">Delivery Challan</td>
     </tr>
    </thead>
    <tr>
     <!-- Left: Company Info -->
     <td width="65%" style="border-right: 1px solid #000000; padding: 8px;">
      <div style="margin-bottom: 6px;" v-if="admin?.company?.logo">
       <img :src="admin.company.logo_url" alt="Logo"
    style="height: 50px; width: auto; object-fit: contain;" />
      </div>
      <div class="fs-14 font-bold text-dark text-uppercase" style="margin-bottom: 3px;">
       {{ admin?.company?.company_name }}
      </div>
      <div class="fs-10 text-gray" style="line-height: 1.4;">
       <template v-if="admin?.company?.address">
        Address: {{ admin.company.address }}, {{ admin.company.city }} - {{ admin.company.pincode }}<br>
       </template>
       <template v-if="admin?.company?.gst">
        <strong>GSTIN:</strong> {{ admin.company.gst }}
        <span v-if="admin?.company?.email"> | </span>
       </template>
       <template v-if="admin?.company?.email">
        <strong>Email:</strong> {{ admin.company.email }}
       </template>
      </div>
     </td>

     <!-- Right: Challan Details -->
     <td width="35%" style="padding: 8px;">
      <table width="100%" class="detail-table fs-11">
       <tr>
        <td class="text-gray" style="width: 45%;">Challan No:</td>
        <td class="text-right font-bold">{{ challan.challan_number }}</td>
       </tr>
       <tr>
        <td class="text-gray">Dispatch Date:</td>
        <td class="text-right font-bold">{{ formatDate(challan.dispatch_date) }}</td>
       </tr>
       <tr v-if="challan.reference_no">
        <td class="text-gray">Reference No:</td>
        <td class="text-right font-bold">{{ challan.reference_no }}</td>
       </tr>
       <tr>
        <td class="text-gray">Status:</td>
        <td class="text-right font-bold text-uppercase">{{ challan.status }}</td>
       </tr>
      </table>
     </td>
    </tr>
   </table>

   <!-- ========== RECIPIENT & DETAILS ========== -->
   <table width="100%" cellpadding="0" cellspacing="0" style="margin-top: 8px;">
    <tr>
     <!-- Left: Deliver To -->
     <td width="50%" class="bordered-box" style="padding: 8px; border-right: none;">
      <div class="fs-10 text-uppercase font-bold text-dark" style="margin-bottom: 4px;">
       Deliver To ({{ recipientType() }})
      </div>
      <div class="fs-11 font-bold text-uppercase">{{ recipientName() }}</div>
      <div class="fs-10 font-bold text-uppercase" v-if="recipientPhone()">{{ recipientPhone() }}</div>
      <div class="fs-10 font-bold text-uppercase" v-if="recipientEmail()">{{ recipientEmail() }}</div>
     </td>

     <!-- Right: Other Details -->
     <td width="50%" class="bordered-box" style="padding: 8px;">
      <div class="fs-10 text-uppercase font-bold text-dark" style="margin-bottom: 4px;">
       Other Details
      </div>
      <div class="fs-10 text-gray" style="line-height: 1.5;">
       <strong>Warehouse:</strong> {{ challan.warehouse?.name || '-' }}<br>
       <template v-if="challan.warehouse?.address">
        {{ challan.warehouse.address }}, {{ challan.warehouse.city }}, {{ challan.warehouse.state }} - {{ challan.warehouse.pincode }}<br>
       </template>
       <strong>Purpose:</strong> {{ challan.purpose || '-' }}
      </div>

      <template v-if="challan.transporter_name">
       <div class="fs-10 text-uppercase font-bold text-dark" style="margin-top: 8px; margin-bottom: 4px;">
        Transport Details
       </div>
       <div class="fs-10 text-gray" style="line-height: 1.5;">
        <strong>Transporter:</strong> {{ challan.transporter_name }}<br>
        <strong>Vehicle No:</strong> {{ challan.vehicle_no || '-' }}
       </div>
      </template>
     </td>
    </tr>
   </table>

   <!-- ========== ITEMS TABLE ========== -->
   <table class="items-table bordered-box" cellspacing="0" cellpadding="0" style="position: relative; z-index: 1;">
    <thead>
     <tr>
      <th width="5%" class="text-center">S.No.</th>
      <th width="35%">Description of Goods</th>
      <th width="12%" class="text-center">HSN/SAC</th>
      <th width="10%" class="text-center">Qty</th>
      <th width="12%" class="text-right">Rate</th>
      <th width="10%" class="text-center">Tax</th>
      <th width="16%" class="text-right">Amount</th>
     </tr>
    </thead>
    <tbody>
     <tr v-for="(item, index) in challan.challan_items" :key="item.id">
      <td class="text-center fs-10">{{ index + 1 }}</td>
      <td>
       <strong class="text-dark fs-10">{{ item.item?.name || item.name }}</strong>
       <br v-if="item.item?.code">
       <span class="text-gray" style="font-size:9px;" v-if="item.item?.code">{{ item.item.code }}</span>
      </td>
      <td class="text-center fs-10 text-gray">{{ item.hsn_code || '-' }}</td>
      <td class="text-center fs-10">{{ item.quantity }} {{ item.unit || item.item?.unit || '' }}</td>
      <td class="text-right fs-10">{{ parseFloat(item.unit_price || 0).toFixed(2) }}</td>
      <td class="text-center fs-10">{{ parseFloat(item.tax_amount || 0).toFixed(2) }}</td>
      <td class="text-right font-bold fs-10 text-dark">{{ parseFloat(item.total || 0).toFixed(2) }}</td>
     </tr>

     <!-- Empty filler rows -->
     <tr v-for="n in Math.max(0, 3 - (challan.challan_items?.length || 0))" :key="'empty-'+n">
      <td class="text-center fs-10">-</td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
     </tr>
    </tbody>
   </table>

   <!-- ========== TOTALS & FOOTER ========== -->
   <table width="100%" cellpadding="0" cellspacing="0" class="totals-section bordered-box" style="position: relative; z-index: 1;">
    <tr>
     <!-- Left: Amount in Words -->
     <td width="60%" style="border-right: 1px solid #000000; border-bottom: 1px solid #000000; padding: 8px; vertical-align: top;">
      <div class="fs-10 text-uppercase font-bold text-dark" style="margin-bottom: 3px;">
       Amount Chargeable (in words)
      </div>
      <div class="fs-11 font-heavy text-dark" style="text-transform: capitalize;">
       {{ $amountInWords(challan.total || 0) }}
      </div>
     </td>

     <!-- Right: Totals -->
     <td width="40%" style="padding: 0; border-bottom: 1px solid #000000; vertical-align: top;">
      <table class="totals-right-table">
       <tr>
        <td class="label-cell">Subtotal</td>
        <td class="value-cell">{{ parseFloat(challan.subtotal || 0).toFixed(2) }}</td>
       </tr>

       <!-- Tax breakdown (parsed from JSON string) -->
       <template v-if="hasTaxBreakdown">
        <tr v-for="(taxData, key) in parsedTaxBreakdown" :key="key">
         <td class="label-cell">{{ taxData.name || 'Tax' }} ({{ taxData.rate || 0 }}%)</td>
         <td class="value-cell">{{ parseFloat(taxData.tax_amount || 0).toFixed(2) }}</td>
        </tr>
       </template>

       <!-- Fallback: simple tax total -->
       <tr v-else-if="parseFloat(challan.tax_amount || 0) > 0">
        <td class="label-cell">Tax</td>
        <td class="value-cell">{{ parseFloat(challan.tax_amount || 0).toFixed(2) }}</td>
       </tr>

       <!-- Grand Total -->
       <tr>
        <td class="grand-label">TOTAL</td>
        <td class="grand-value">INR {{ parseFloat(challan.total || 0).toFixed(2) }}</td>
       </tr>
      </table>
     </td>
    </tr>

    <!-- Signature -->
    <tr>
     <td colspan="2" class="text-right" style="padding: 10px 8px;">
      <div style="height: 40px; margin-bottom: 5px; text-align: right;">
       <img v-if="admin?.company?.signature" :src="admin.company.signature_url" alt="Signature"
    style="height: 40px; width: auto; object-fit: contain;">
      </div>

      <div style="font-weight: bold; color: #000000; margin-top: 10px; margin-bottom: 5px;">
       For <strong>{{ admin?.company?.company_name }}</strong>
      </div>

      <div class="fs-10 text-dark" style="border-top: 1px solid #000000; display: inline-block; padding-top: 4px; min-width: 150px; text-align: center;">
       Authorized Signatory
      </div>
     </td>
    </tr>
   </table>

   <div class="footer-line">
    This is a computer generated Delivery Challan.
   </div>
  </div>

 </div>

 <!-- Loading state -->
 <div v-else class="content">
  <div class="text-center py-5">
   <span class="text-muted">Loading...</span>
  </div>
 </div>
</template>